require('./bootstrap');
window.Vue = require('vue');
window.moment = require('moment');
import postError from './helpers/postError'
import 'bootstrap';
//import BootstrapVue from 'bootstrap-vue'
//import 'bootstrap-vue/dist/bootstrap-vue.css';
//import WorkHistoryGrid from './components/surveys/WorkHistoryGrid.vue';
// window.Vue.use(BootstrapVue);

// window.Vue.config.errorHandler = function (err, vm, info) {
//     console.log(err);
//     postError(err.message, vm.$options.name, info, null, err);
// }
import * as Vue from 'vue';
window.vue = Vue;

require('sirs-skiptrigger')
require('mutually-exclusive')
require('./alumni4_page1')
require('./end_of_period_11_11a')
require('./helpers/NAGroup')
window.datepicker = require('bootstrap-datepicker');
window.timepicker = require('timepicker');

window.Vue = require('vue');

// Vue.component('DefaultList', require('./components/DefaultList.vue').default);

// const app = new Vue({
//     el: '#app',
//     data: {
//         test: 'beans',
//         clinicianListFields: {
//             id: {
//                 key: 'id',
//                 label: 'ID',
//                 sortable: true
//             },
//             name: {
//                 key: 'name',
//                 label: 'Name',
//                 sortable: true
//             },
//             // icg_id: {
//             //     label: 'ICG Id',
//             //     sortable: true
//             // },
//             // email: {
//             //     label: 'Email',
//             //     sortable: true
//             // },
//             discipline: {
//                 key: 'discipline.name',
//                 label: 'Discipline',
//                 sortable: false
//             },
//             specialty: {
//                 key: 'specialty.name',
//                 label: 'specialty',
//                 sortable: false
//             }
//         }
//     },
//     mounted() {
//         //
//     }
// });

// if (document.getElementById('work-history-grid')) {
//     const WorkHistory = new Vue({
//         el: '#work-history-grid',
//         components: {
//             WorkHistoryGrid
//         },
//         mounted() {
//         }
//     });
// }
import WorkHistoryGrid from './components/surveys/WorkHistoryGrid.vue';

if (document.getElementById('work-history-grid')) {
  var app =  Vue.createApp({

  });
  


    app.component('WorkHistoryGrid', WorkHistoryGrid);
    app.mount("#work-history-grid");
}

window.getRadioValue = function (radioName) {
    var options = document.getElementsByName(radioName),
        value = null;

    for (var i = 0; i < options.length; i++) {
        if (options[i].checked) {
            value = options[i].value
            break;
        }
    }
    return value;
}

window.addGroupEventListener = function(groupName, event, handler) {
    var options = document.getElementsByName(groupName);
    for (var i = 0; i < options.length; i++) {
        options[i].addEventListener(event, handler);
    }
}

window.showElement = function (el) {
    el.classList.remove('hidden');
}
window.hideElement = function (el) {
    el.classList.add('hidden');
}
window.toggleElementDisplay = function (el) {
    if (el.classList.contains('hidden')) {
        showElement(el);
    } else {
        hideElement(el);
    }
}

window.toggleBlockFromGroup = function (groupName, blockId) {
    var block = document.getElementById(blockId);
    var groupVal = getRadioValue(groupName);
    if (groupVal == 1) {
        showElement(block);
    } else {
        hideElement(block);
    }
}

window.sumInputValues = function (inputs) {
    var values = inputs.map(input => {
                    if (typeof input == 'String') {
                        input = document.getElementById(input);
                    }
                    return input.value ? parseInt(input.value) : 0;
                });
    // console.log()
    return values.reduce((a, b) => a + b, 0);
}

window.watchInputValues = function (inputs, callback)
{
    inputs.map(input => {
        if (typeof input == 'String') {
            input = document.getElementById(input);
        }
        return input;
    })
    .forEach(input => {
        input.addEventListener('change', () => {
            callback(inputs)
        });
    });
}
